var Backbone = require('backbone'),
    _ = require('underscore'),
    FloatingCodesView = require('./codesView'),
    FloatingCodesUiModel = require('./codeUiModel');

require('backbone.radio');
require('backbone.babysitter');

// Note: this is really at the page note level so if > 1 note there could be multiple
// ( Events can appear to have been called multiple times -- one for each instance )
// Maybe call the PageNoteFloatingCodeController???

var FloatingCodeController = function( canvasChannel, noteModel ) {

    _.extend(this, Backbone.Events);

    this.canvasChannel = canvasChannel;

    this.shapeViews = new Backbone.ChildViewContainer();
    this.codeViews = new Backbone.ChildViewContainer();

    /**
     * ID:
     * - For now don't need a reference to the model, so just store it's id; maybe need to change in the future.
     * - Use cid: for new notes id is now undefined and channels created from them will not be unique to the note model!
     * - (encountered issue on drag of code boxes when editing a find and redact (new) and non find and redact note at the same time )
     */
    this.id = noteModel.cid;
    this.channel = new Backbone.Radio.channel( 'FloatingCodeChannel:' + this.id );

    this.listenTo( this.channel, 'reasonCodeView.drag', this.onReasonCodeViewDrag );

    this.listenTo( this.canvasChannel, 'scaleFloatingReasonCodeViews', this.updateScale );
    this.listenTo( this.canvasChannel, 'imgCanvas.moveAllCodeBoxesToFront', this.moveCodeViewsToFrontOfCanvas );

     // called from routine in canvas.js activeNote change ... only want called at the note level instance
    this.listenTo( this, 'floatingCodesView.toggleActive', this.toggleActiveCodeViews );

};



_.extend( FloatingCodeController.prototype, {

    addShapeView: function(view) {
        this.shapeViews.add(view);
    },

    removeShapeView: function(view) {

        this.shapeViews.remove(view); //(already destroyed in onBeforeDestroy on shapeView)
        view.destroyConnection();

        // ah: if was attached to others with a model and this wasn't, maybe those shape ids aren't removed ...
        // ensure id removed from all code view model references ....
        this.codeViews.each( function(cv) {
            cv.model.removeShapeViewId(view.cid);
        });

        this._pruneCodeViews();

    },

    update: function(shapeView, uniqueCodeStr) {

        // Always destroy then create a connection for the shapeView
        shapeView.destroyConnection();

        /*
        * Determine if a codeView already exists for the given uniqueCodeStr.
        * ( Note: Babysitter findByCustom will not work when swapping models (when need to add, then remove ... )
        *  and also can't use find by model in this case b/c the model may not exist
        * */
        var existingCodeView =  this.codeViews.find( function(v) {
            return v.model.get('uniqueCodeString') === uniqueCodeStr;
        });

        var shapeIsNewlyDrawn = shapeView.shapeUI.get('isNewlyDrawn');

        /*
        *  If the codeView already exists, point the shapeView point to it.
        *  (wouldn't happen for empty uniqueCodeStr).
        * */
        if ( existingCodeView ) {

            var existingUIModel = existingCodeView.model;

            existingUIModel.addShapeViewId(shapeView.cid);
            shapeView.reasonCodeUiModel = existingUIModel;
            shapeView.createConnection( existingCodeView );

            // Only update layering if newlyDrawn; if drawn from model -- set after all shapes have been drawn
            shapeIsNewlyDrawn &&
                existingCodeView.triggerMethod('updateShapeLayering', shapeView.el );
        }

        /*
        * If the shapeView only has 1 connection, update its codeView to that of uniqueCodeStr (if uniqueCodeStr isn't blank).
        * ( If other shapes also have the combo, this is covered above ).
        * ( Implies there is not already a view for the code combo ) .
        * */
        else if ( uniqueCodeStr.length > 0 && shapeView.reasonCodeUiModel && shapeView.reasonCodeUiModel.get('shapeViewIds').length === 1 ) {

            var codeViewOfShapeView = this.codeViews.findByCid( shapeView.reasonCodeUiModel.get('codeViewId') ),
                existingUIModel = codeViewOfShapeView.model;

            existingUIModel.set({
                uniqueCodeString: uniqueCodeStr
            });

            existingUIModel.addShapeViewId(shapeView.cid);
            shapeView.reasonCodeUiModel = codeViewOfShapeView.model;

            // Instead of update could destroy and re-render
            codeViewOfShapeView.triggerMethod('updateText', shapeView.selectedCodes.getCodesAsString('\n'), shapeView.el.getBBox() );
            shapeView.createConnection(codeViewOfShapeView);

        }
        /*
        * Else: codeView doesn't exist && shapeView is not connected to just one codeView.
        * ( and uniqueCodeStr isn't blank ).
        * Create a new codeView with uniqueCodeStr.
        * (Prior if rules out it being connected to multiple ).
        * The ONLY a place new uiModel/codeView is created.
        * */
        else if ( uniqueCodeStr.length > 0 ) {

            var sm = shapeView.shapeModel,
                renderBoxFromShapeModelPts = this._renderNewBoxFromPts( sm, shapeView, shapeIsNewlyDrawn, uniqueCodeStr );

            var newCodeUIModelOptions = {
                renderBoxFromShapeModelPts: renderBoxFromShapeModelPts // needed on here .. it's really for the shape and can be interpreted (?)
            };

            if (renderBoxFromShapeModelPts) {

                var boxModel = sm.getBox();

                // Adjust the points on this version of the boxModel -- used for rendering  -- should update the reference on the shapeModel as well.
                // ... maybe want to clone instead ?
                boxModel.set( 'points', sm.getAdjustedBoxPts() );

                _.extend( newCodeUIModelOptions, {
                    boxModel: boxModel,
                    connectionModel: sm.getConnection()
                });
            }

            var newCodeUiModel = new FloatingCodesUiModel({
                uniqueCodeString: uniqueCodeStr,
                pgDPI: sm.pageModel.getDPI(), // could also store on here and cache on creation ... (all on same page)
                parentNoteIsActive: sm.uiModel.get('isActive')
            }, newCodeUIModelOptions);


            var newCodeView = this._createCodeLettersView( shapeView.el.paper , newCodeUiModel, sm.pageModel )
                .render(
                    shapeView.selectedCodes.getCodesAsString('\n'), // get the from the ui model ?
                    shapeView.el.getBBox(0)
                );

            /*
            * Only update layering if newlyDrawn; if drawn from model -- set after all shapes have been drawn.
            * Newly drawn shapes will be put in front by default, show use shapeView.el instead of paper.top.
            * */
            shapeIsNewlyDrawn && newCodeView.triggerMethod('updateShapeLayering', shapeView.el );

            shapeView.reasonCodeUiModel = newCodeUiModel; // (set first before the connection -- attrs are necessary for drawing it)
            shapeView.createConnection(newCodeView);

            newCodeUiModel.addShapeViewId( shapeView.cid );
            newCodeUiModel.set('codeViewId', newCodeView.cid);

            this.codeViews.add( newCodeView, uniqueCodeStr );

            // TODO: if code view will be placed in default position -- don't allow to it cover another code box

        }

        this._pruneCodeViews();
    },

    /**
     * Determines whether to draw a new code box from points or
     * allow it to be generated on the fly when rendered ( where size is derived )
     * Would set the box codeUi model's codesWerePositioned to true
     */
    _renderNewBoxFromPts: function( sm, shapeView, shapeIsNewlyDrawn, uniqueCodeStr ) {

        // First handle new logic for find and redact
        // Of now: the original shape models will not have a box set until the have been 'applied' or canvas re-rendered
        // ( we don't care about for the other 2 cases in the update routine, since no new model/view is created )
        // TODO: combo with below logic I think -- originalUniqueReasonCodeString !== uniqueCodeStr

        if ( sm.isFindAndRedactShape ) {

            /**
             * Handle Case where codes from F&R interface on page different than the current canvas.
             * Box is dirty now implies:
             * 1) set from different while not on the same page
             * 2) came from different mode
             */
            if ( sm.getBoxIsDirty() ) {

                // For now set back immediately
                // TODO: do this after all shapes are rendered? perhaps clearer in WF debug
                sm.setBoxIsDirty( false );
                return false;
            }

            var hasBox = sm.getBox(); // points were set, these don't get saved

            if ( hasBox ) {

                // Maybe I can get this from the model so if change when not rendered we are good
                // Other predicates from below:
                // Codes were changed by user ( from below ) and canvas later 're-rendered' (like after a page change) -- equivalent of being saving from DB (below)
                // Required, otherwise if box points will be off if codes changes after a re-render !
                // Eg: search that results in > 1 hit; change page, go back to page, change codes of a zone, you'll be off
                // TODO: now could be handle with 'boxIsDirty' above

                if ( shapeView.originalUniqueReasonCodeString !== uniqueCodeStr )
                    return false;

                if ( shapeView.nLastSelectedCodes === 0 )
                    return false;

                return true;

            }

            return false;
        }

        if ( sm.isConvertingToFloatingCodes || shapeIsNewlyDrawn )
            return false;

        // Condition necessary for shapes read in from the db (!shapeIsNewlyDrawn) and whose codes were changed by the user.
        // Without, the prior points saved on the model will be set, and then the code view will not be positioned.
        // ( new views need to be placed at default position, and won't be if the points are set )
        // ( we don't care about for the other 2 cases in the update routine, since no new model/view is created )
        if ( shapeView.originalUniqueReasonCodeString !== uniqueCodeStr )
            return false;

        // Above case doesn't handle situation where a shape is saved with one reasonCode,
        // and during an edit all reason codes are removed, and then then original reason code is put back.
        // In this case, we want a new box placed at 'default position', not set from existing points, which would result in error (placement at 0,0).
        // ( Above condition still necessary for when shape is attached to box with > 1 reason code ).
        // Note: there's probably a clearer way to organize all of this ....
        if ( shapeView.nLastSelectedCodes === 0 )
            return false;

        return true;

    },

    /*
    *  Prune any code views that aren't attached to any shapes.
    *  Get the actual uniqueCodeStrs assigned to each shape,
    *  then loop through each code view.
    *  If the uniqueCodeStr of the view isn't one that exists, remove the view.
    * */
    _pruneCodeViews: function() {

        var uniqueCodeStrings = this._getExistingUniqueCodeStrings();

        this.codeViews.each( function(cv) {

            var uid = cv.model.get('uniqueCodeString');

            if ( !_.contains(uniqueCodeStrings, uid) ) {

                // remove it
                // TODO: this should be a fn -- remove the view and connection to its shape views

                cv.destroy();
                this.codeViews.remove(cv);

                /*
                * I forget why this is here but it's necessary.
                * There may be an issue here causing the shapeViews reasonCodeUiModel to get out of sync with it's connection
                * -- see comment in shapeView._setConnectionStrokeWidthAndDashArray.
                * */
                var attachedShapeViewIds = cv.model.get('shapeViewIds');
                _.each( attachedShapeViewIds, function(cid) {

                    var sv = this.shapeViews.findByCid(cid);
                    sv.reasonCodeUiModel = null;  // so now this acts like a flag for is connected

                }, this);
            }

        }, this);
    },

    _getExistingUniqueCodeStrings: function() {
        var uniqueCodeStrings = this.shapeViews.map(function(s) {
            return s.selectedCodes.getCodesAsString();
        });
        uniqueCodeStrings = _.uniq( uniqueCodeStrings );
        uniqueCodeStrings = _.without( uniqueCodeStrings, '');
        return uniqueCodeStrings;
    },

    _createCodeLettersView: function(paper, reasonCodeViewModel, pageModel) {

        return new FloatingCodesView({

            noteCodesChannel: this.channel,
            canvasChannel: this.canvasChannel,
            model: reasonCodeViewModel,
            paper: paper,
            pageModel: pageModel,
            originalScale: this.canvasChannel.request('currentScaleValue')

        });

    },

    // TODO: could also cache those on drag start, etc
    // may want to throttle this especially if many are attached ... but this looks choppy
    onReasonCodeViewDrag: function(uiModel) {

         var attachedViewIds = uiModel.get('shapeViewIds');
         for (var i=0; i<attachedViewIds.length; i++) {
             this.shapeViews.findByCid( attachedViewIds[i]).updateConnection();
         }

    },

    // currently unused
    getShapeViewsOfUniqueCodeString: function(uid) {

        return this.shapeViews.filter( function(v) {
            return v.reasonCodeUiModel.get('uniqueCodeString') === uid;
        });

    },
    // currently unused
    getCodeViewsOfUniqueCodeString: function(uid) {
        return this.codeViews.filter( function(v) {
            return v.model.get('uniqueCodeString') === uid;
        });
    },

    getCodeViewOfUniqueCodeString: function(uid) {
        return this.codeViews.find( function(v) {
            return v.model.get('uniqueCodeString') === uid;
        });
    },

    getShapeViewByShapeModel: function(sm) {
        return this.shapeViews.find( function(v) {
            return v.shapeModel.cid === sm.cid;
        });
    },

    // only want called once for each code view, so not triggering from the codeViews themselves, when they update scale
    // (they update first in the scale change workflow)
    updateScale: function(scale, lastScale) {

        // first update the scale of all codeViews
        this.codeViews.each( function(cv) {
            cv.updateScale(scale, lastScale); // prob as event ....  //var args = Array.prototype.slice.call(this);
        });

        // now update the connections to all the shape views (if they are connected)
        this.shapeViews.each( function(sv) {
           sv.connection && sv.scaleConnection(scale); // TODO: should have a is connected fn ...
        });

    },

    // Note: NOT forwarded from each shape view.  They are called first and then this is called after all completed.
    // Only called once after all shape views have been 'toggled'.
    // TODO: maybe store the paper instance on here and use throughout ... no need to keep passing / deriving (except mem ref issues)

    // Layer and enable drag
    toggleActiveCodeViews: function(isActive, paper) {

        this.codeViews.each( function(cv) {

            //  capture the event here & forward to all code views utilizing the shared ui model
            //  due to nature of attribute only changing once, will only trigger a change to code view the first time this is set
            // (now that not passed from shapeView -- this is a separate event -- no longer as big an issue; will be called once anyway)

            // Paper.top will be the highest of all zones in the note; this is necessary so code views are put above zones they aren't attached to
            // this is somewhat sloppy (should really be storing the position in a data model somewhere -- and
            // ultimately may need to), but it should work BECAUSE toggleActive on the shape set's each shape 'toFront'

            cv.model.set('parentNoteIsActive', isActive, {
                shapeViewEl: paper.top
            });

        }, this);

    },

    // Position the codes views from their models' box points.
    // Then update the connections of the shape views.
    // TODO: is this still used ???
    positionCodeViewsFromModelPts: function() {

        // should apply to all (if canvas not yet rendered, they can't be new yet)
        this.codeViews.each( function(cv) {
            cv.positionFromCoordinates();
        }, this);

        // would apply to all, forget getting those attached, though that's more performant
        this.shapeViews.each( function(sv) {
            sv.updateConnection();
        });

    },

    // Really only called for notes converting from normal to floating.
    positionCodeViewsAtDefaultPosition: function() {

        this.codeViews.each( function(cv) {

            // not sure what to align with ... now using the first ... (could be multi attached)
            // may want to use the topmost???
            var shapeViewIdToAlignWith = cv.model.get('shapeViewIds')[0];
            var shapeViewToAlignWith = this.shapeViews.findByCid( shapeViewIdToAlignWith );

            // *** For some reason when rendered entering from different page, the size of the text isn't correct.
            // Below is a hack to reset the text attribute now that it's in the DOM so its size is correct prior to calling position
            // uses the size of the text box in it's calculations
            cv.textEl.attr('text', cv.textEl.attr('text') ); // TODO:  fn ..

            cv.placeAtDefaultPosition( shapeViewToAlignWith.el.getBBox(0) );

        }, this);


        this.shapeViews.each( function(sv) {
            sv.updateConnection();
        });

    },
    // called after all shapes have been rendered (from model) on the canvas
    moveCodeViewsToFrontOfCanvas: function( paper ) {

        this.codeViews.each( function(cv) {
            cv.triggerMethod( 'updateShapeLayering', paper.top );
        });

        // TODO: may also want to move the line connections the front
    },

    destroy: function() {

        this.channel.reset();

        this.stopListening();

        this.codeViews.each( function(cv) {
            cv.destroy();
            this.codeViews.remove(cv);
        }, this);


        this.shapeViews.each( function(sv) {
           sv.destroy();
           this.shapeViews.remove(sv);
        }, this);

    }

});


module.exports = FloatingCodeController;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/redaction/floatingCodes/controller.js
 ** module id = 245
 ** module chunks = 0
 **/